<template>
    <div class="xczx">
        <img src="./img/bg.png" alt="" class="bg">
        <div class="content">
            <div class="guide_text">
                多年来，蓝海密剑主办方——东航期货，围绕国家“实施乡村振兴”战略总要求，积极响应期货行业服务实体经济号召，协同母公司东航金控，在云南沧源、双江等地，践行产业帮扶、教育帮扶、消费帮扶等，以金融力量，为当地乡村振兴打造高速引擎。
            </div>
            <div class="swiper">
                <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
                    <van-swipe-item>
                        <img src="./img/swipe_01.png" alt="">
                    </van-swipe-item>
                    <van-swipe-item>
                        <img src="./img/swipe_02.png" alt="">
                    </van-swipe-item>
                    <van-swipe-item>
                        <img src="./img/swipe_03.png" alt="">
                    </van-swipe-item>
                    <van-swipe-item>
                        <img src="./img/swipe_04.png" alt="">
                    </van-swipe-item>
                  </van-swipe>
            </div>
            <div class="swiper_text">
                <左右滑动查看更多>
            </div>
            <div class="title">
                <img src="./img/title.png" alt="">
            </div>
            <div class="ask_text">
                值此蓝海密剑十五周年之际，组委会面向全市场交易者，公开征集“蓝海密剑乡村振兴事业伙伴”，以汇聚期货力量，共襄助力乡村振兴盛举。
            </div>
            <div class="end">本次调研活动已结束。</div>
            <!-- <div class="radio">
                <div>
                    1.您愿意加入我们，一起助力乡村振兴吗？
                </div>
                <van-radio-group v-model="wish" direction="horizontal" @change="changeHandle">
                    <van-radio name="0">
                        愿意
                      <template #icon="props">
                        <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                      </template>
                    </van-radio>
                    <van-radio name="1" style="padding-left: 15px;">
                      不愿意
                      <template #icon="props">
                        <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                      </template>
                    </van-radio>
                  </van-radio-group>
            </div> -->
            <!-- <div class="checkbox">
                <div>
                    2.您愿意采取以下哪种形式助力乡村振兴？
                </div>
                <van-checkbox-group v-model="result" @change="changeCheckbox">
                    <van-checkbox name="定额参与" v-model="quota">
                        定额参与
                        <template #icon="props">
                          <img class="img-icon" :src="props.checked ? activeIconSqure : inactiveIconSqure" />
                        </template>
                    </van-checkbox>
                    <van-checkbox name="大赛奖金参与" v-model="bonus">
                        大赛奖金参与
                        <template #icon="props">
                          <img class="img-icon" :src="props.checked ? activeIconSqure : inactiveIconSqure" />
                        </template>
                    </van-checkbox>
                    <van-checkbox name="增收手续费"  v-model="commission">
                        增收交易手续费参与（限东航期货参赛选手）
                        <template #icon="props">
                          <img class="img-icon" :src="props.checked ? activeIconSqure : inactiveIconSqure" />
                        </template>
                    </van-checkbox>
                </van-checkbox-group>
            </div> -->
            <!-- <div class="tips">
                提示：本次调研无费用，您的意向将为我们指引助力乡村振兴新方向，请您据实填写。
            </div>
            <div class="dash">
                <img src="./img/dash.png" alt="">
            </div>
            <div class="submit_message_box" v-show="wish === '0'">
                <div><span>姓　名</span><input type="text" v-model="name"></div>
                <div><span>手机号</span> <input type="number" v-model="mobile" ></div>
                <van-button color="#cc0a00" @click="submit()">提 交</van-button>
            </div> -->
        </div>
        <van-overlay :show="showAlert" @click="showAlert = false">
            <div class="wrapper">
              <div class="alertMessage">
                {{ alertMessage }}
              </div>
            </div>
        </van-overlay>
    </div>
  </template>

  <script>
    /* eslint-disable */
    import { Dialog } from 'vant'
    import ajax from '@/common/ajax/ajax'
    import activeIcon from './img/activeIcon.png'
    import activeIconSqure from './img/activeIconSqure.png'
    import inactiveIconSqure from './img/inactiveIconSqure.png'
    import inactiveIcon from './img/inactiveIcon.png'
    export default {
      name: 'xczx',
      data () {
        return {
            wish: '',
            activeIcon: activeIcon,
            inactiveIcon: inactiveIcon,
            activeIconSqure: activeIconSqure,
            inactiveIconSqure: inactiveIconSqure,
            quota: false,
            bonus: false,
            commission: false,
            showAlert: false,
            alertMessage: '',
            name: '',
            mobile: '',
            result: ['','','']
        }
      },
      methods:{
        changeHandle(name) {
            if(name === '1') {
                // 不同意
                Dialog.confirm({
                    message: '您确认不参与助力乡村振兴吗？',
                })
                .then(() => {
                    // 确认
                    this.name = ''
                    this.mobile = ''
                    this.submitHandle()
                }).catch(() => {
                    // 取消
                    this.clear()
                })
            }
        },
        changeCheckbox(names) {
            console.log(names, 'names');
            if(names.length > 3) {
                // 选中默认勾选同意
                this.wish = '0'
            }
        },
        submit() {
            const namereg = /^.*[\u4e00-\u9fa5].*$/
            if(this.result.length < 4) {
                this.alertMessage = '请至少选择一种助力形式'
                this.showAlert = true
                return
            }
            if (!this.name) {
                this.alertMessage = '请输入姓名'
                this.showAlert = true
                return
            }
            if (!namereg.test(this.name)) {
                this.alertMessage = '姓名请至少输入一个汉字'
                this.showAlert = true
                return
            }
            const myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/ //11位手机号码正则
            if (!myreg.test(this.mobile)) {
                this.alertMessage = '输入正确的11位手机号码'
                this.showAlert = true
                return
            }
            let helpWay = '助力方式：'
            const arr = this.result.filter(item => item !== '')
            helpWay += arr.join('.')
            console.log(helpWay, 'helpWay')
            this.submitHandle(helpWay)
        },
        clear() {
            this.submitShow = false
            this.mobile = ''
            this.name = ''
            this.wish = ''
            this.result = ['','','']
        },
        submitHandle(helpWay) {
            const formData = {
                wish: this.wish,
                name: this.name,
                mobile: this.mobile,
                helpWay: helpWay || '',
            }
            console.log(formData, 'formData')
            ajax.ruralPlaningResearch(formData).then((data) => {
                console.log(data, 'data')
                if(data.resultStatus === '0') {
                    this.alertMessage = '感谢您的参与！'
                    this.showAlert = true
                    this.clear()
                }
            }).catch(err => {
                console.log(err, '-------------');
                this.alertMessage = `提交失败，请稍候再试`
                this.showAlert = true
            })
        }
      }
    }
  </script>
  <style scoped>
    .xczx {
        width: 100vw;
        overflow: auto;
        font-family: "思源黑体";
        color: #510703;
        position: relative;
    }
    .bg{
        display: block;
        width: 100%;
        min-height: 900px;
        min-height: 1300px;
    }
    .content {
        width: 90%;
        min-height: 900px;
        max-height: 1200px;
        position: absolute;
        top: 18%;
        left: 50%;
        transform: translateX(-50%);
        background-color: #fff8e6;
	    border-radius: 25px;
        font-size: 18px;
        color: #510703;
        padding-bottom: 20px;
    }
    .guide_text {
        text-indent: 2em;
        padding: 30px 20px;
    }
    .swiper {
        padding: 0px 20px;
    }
    .swiper img {
        width: 100%;
        height: 200px;
        border-radius: 5px;
    }
    .swiper_text {
        font-size: 15px;
        line-height: 25px;
        color: #e39d5c;
        text-align: center;
        padding: 5px 20px 0px 0px;
    }
    .title {
        display: flex;
        justify-content: center;
        margin: 20px 0px;
    }
    .title img {
        width: 80%;
        object-fit: contain;
    }
    .ask_text {
        text-indent: 2em;
        padding: 0px 20px;
    }
    /deep/ .img-icon{
        width: 20px !important;
        height: 20px !important;
        vertical-align: 0px !important;
    }
    .van-radio-group {
        height: 50px;
        padding-left: 15px;
    }
    .radio {
        padding: 20px;
    }
    .checkbox {
        padding: 0px 20px;
    }
    .van-checkbox {
        height: 50px;
        padding-left: 15px;
    }
    .van-checkbox__label {
        vertical-align: -2px;
    }
    .tips {
        font-size: 15px;
        line-height: 25px;
        color: #a2a2a2;
        padding: 20px;
    }
    .dash {
        text-align: center;
    }
    .dash img {
        width: 70%;
    }
    .submit_message_box {
        text-align: center;
        margin-top: 20px;
    }
    .submit_message_box div {
        margin-bottom: 20px;
    }
    .submit_message_box div input {
        width: 50%;
        border-radius: 5px;
        border: solid 1px #171717;
        background-color: #fff8e6;
        padding-left: 15px;
    }
    .submit_message_box div span {
        display: inline-block;
        font-size: 18px;
        width: 80px;
        margin-right: 10px;
    }
    .van-button {
        width: 150px;
        margin-top: 20px;
    }
    .wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
      }
    .alertMessage {
      width: 270px;
      padding: 15px 10px;
      text-align: center;
      background-color: #fff;
      color: red;
      border-radius: 5px;
    }
    .end {
        text-align: center;
        font-size: 25px;
        margin-top: 10%;
    }

  </style>



// WEBPACK FOOTER //
// index.vue?77c5b6ab